import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Link, Skeleton, Stack, Typography } from '@mui/material'

import { useLazyGetInternalOrganizationGamesCountQuery } from '../../../../api/organizations'
import { InternalOrganization } from '../../types/Organizations'
import { hasUnlimitedGameSlots } from '../helpers/organizationHelpers'

type GameSlotsCountProps = {
  organization: InternalOrganization
}

export const GameSlotsCount: FC<GameSlotsCountProps> = ({ organization }) => {
  const { t } = useTranslation()
  const [loadCount, { data, isFetching, isError }] = useLazyGetInternalOrganizationGamesCountQuery()
  const max = hasUnlimitedGameSlots(organization) ? '∞' : organization.maxGameSlots

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Typography variant="body2">{t('internal-csm:organizations_game_slots')}</Typography>
      <Stack direction="row" alignItems="center">
        {isFetching ? (
          <Skeleton width={20} />
        ) : data !== undefined && !isError ? (
          <Typography variant="body2">{data}</Typography>
        ) : (
          <Link component="button" variant="body2" color={isError ? 'error' : 'primary'} onClick={() => loadCount(organization.id, true)}>
            {isError ? t('internal-csm:organizations_retry') : t('internal-csm:organizations_show')}
          </Link>
        )}
        <Typography variant="body2">/{max}</Typography>
      </Stack>
    </Stack>
  )
}
